import { Link } from "react-router-dom";
import "./homepage.css";

export default function SelfIntro() {
  return (
    <div className="about-column">
      <section className="about-section" aria-labelledby="about-title">
        <h2 id="about-title">About me</h2>
        <p>I'm Zijie Lin, also known as Enqurance.</p>
        <p>
          I studied Computer Science at the National University of Singapore and
          Beihang University. During my studies, I worked on large language
          models at both universities, with guidance from Professor Bryan at
          NUS.
        </p>
        <p>
          I now work at Alibaba as an algorithm engineer, focusing on Agent
          Harness.
        </p>
        <Link className="text-link" to="/resume">
          More about my experience <span aria-hidden="true">↗</span>
        </Link>
      </section>
      <figure className="travel-portrait">
        <img
          src="https://raw.githubusercontent.com/Enqurance/Figures/main/c374677c0422b5d75d12e595770424bb.png"
          alt="A moment from my trip to Istanbul"
          loading="lazy"
        />
        <figcaption>
          <span>Istanbul, Türkiye</span>
          <span>2025</span>
        </figcaption>
      </figure>
      <section className="about-section life-section">
        <h2>Outside work</h2>
        <p>
          Programming, photography, and travelling. A game of League of Legends
          or Valorant. New places, old friends, and the moments in between.
        </p>
        <div className="cat-pair">
          <img
            src="https://raw.githubusercontent.com/Enqurance/Figures/main/202408281602731.png"
            alt="My cat Xiangxiang"
            loading="lazy"
          />
          <img
            src="https://raw.githubusercontent.com/Enqurance/Figures/main/202408281602980.jpg"
            alt="My cat Oubao"
            loading="lazy"
          />
        </div>
        <p className="photo-note">
          Xiangxiang & Oubao — two lovely members of the family.
        </p>
        <p>
          I’m grateful for a happy life with my parents and our two cats, and
          for the friends I’ve met along the way.
        </p>
      </section>
    </div>
  );
}
